import { getDefaultExportFromCjs } from '../../_virtual/_commonjsHelpers.mjs';
import { c as capitalize_1 } from './capitalize.mjs';
import { _ as _createCompounder } from './_createCompounder.mjs';

var capitalize = capitalize_1,
    createCompounder = _createCompounder;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

var camelCase_1 = camelCase;

const camelCase$1 = /*@__PURE__*/getDefaultExportFromCjs(camelCase_1);

export { camelCase$1 as default };
